/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveLexicon.defs'
export { main as default } from './resolveLexicon.defs'
